// HELPERS FUNCTIONS --------------------

// Custom function to escape special characters in selectors(used for some complicated variable concatenations)
function escapeSelector(selector) {
  // replacing the unwanted characters from jquery or js selectors using regex
  return selector.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
// end function
}


// -------- END OF HELPER FUNCTIONS -----


// Mega menu Js

function checkForAttr(attr) {
        if (typeof attr !== typeof undefined && attr !== false) {
            var result = 1;
        } else {
            var result = 0;
        }
  return result; 
  
  console.log('checkForAttr('+attr+'); result: ' + result);
  
    }
(function(window, $) {
  
  /*-------------------------------------0E1-T488 - Berry Bowls have innacurate in stock information - Harwinder Singh - 23-Aug-2024 -> disabling the first element because "out of stock" for now  -----------------------------------------*/
   // adding condition for "berry-bowls-mugs-workshops" product, so it only works for this particular product

  // // set the path variable to the current url path. This is not the full url. 
  // let path = window.location.pathname;
  // // check to see if the path includes the Berry Bowls and Mugs Workshops page. This code will only fire if we're on this page. 
  // if(path.includes( '/berry-bowls-mugs-workshops' ) ) {
  //   // disabling the first option as it is out of stock for now
  //   document.querySelector("#SingleOptionSelector-pillow-products-0 > option:nth-child(1)").disabled = true
  //   // selecting the second option so that the "out of stock" option is not selected by default
  //   document.querySelector("#SingleOptionSelector-pillow-products-0 > option:nth-child(2)").selected = true
  //   // end if statement
  // }
  /*---------------------------------------END of 0E1-T488 ---------------------------------------------------------*/

  
  $(document).ready(function() {
    
	  $(document).on('input','input[type="number"]', function(){
      
      var clearedValue = $(this).val().replace(/^0+/, '');
      
        console.log('clearedValue: ' + clearedValue);
      if( $(this).val() !== clearedValue){
        $(this).val(clearedValue);
      }
      
      if($(this).val() > Number( $(this).attr('max'))){
        $(this).val($(this).attr('max'));
      }
      else if($(this).val() < Number( $(this).attr('min'))){
        $(this).val($(this).attr('min'));
        console.log('value under the minimum');
      } 
      
      console.log("$('input[type='number']').bind('input', function(){}");
    })
      /*
      $(document).on('click', '.js-qty__adjust',function(){ 
      var input = $(this).parents('.quantity-selector').find('input');
      var val = Number(input.val());
                  console.log('value before add: ' + val);
      if($(this).hasClass('quantity__minus')){
        
        //removing from qty
        
         if(val > 1){
       input.val(val - 1);
      }
      else if(checkForAttr(input.attr('min')) == 1){
       input.val(input.attr('min'));
      }
        else{
          input.val(0);
        }
         }
         else{
           // adding to qty
           
           if(checkForAttr(input.attr('max')) == 1 ){
             var max = input.attr('max');
             console.log('max: '+ max);
             if(input.val() < max){
         input.val(val + 1);
                console.log('changed to: ' + val +' + '+ 1);
             }
           }
           else{
             input.val(val + 1);
             console.log('changed to: ' + val +' + '+ 1);
           }
         }
    })
 
    */
    $('.mega-menu-section-wrapper').each(function( key, value ) {
      var dataDropdown = $(value).data('dropdown');
      $('.mega-menu-list-item ').find('a[data-dropdown-rel=' + dataDropdown + ']').after($(this).clone());
      $('header.site-header').append($(this).clone());
    });

    $('li.mega-menu-list-item > a').on('click', function(e) {
      e.preventDefault();
      var dataDropdown = $(this).data('dropdown-rel');
      $('body').find('.mega-menu-section-wrapper').hide();
      if($('header.site-header > .mega-menu-section-wrapper[data-dropdown=' + dataDropdown + ']').hasClass('currentMenu')) {
        $('header.site-header > .mega-menu-section-wrapper[data-dropdown=' + dataDropdown + ']').removeClass('currentMenu');
        $('body').find('.mega-menu-section-wrapper').fadeOut( "fast", "linear");
      } else {
        $('body').find('.mega-menu-section-wrapper').removeClass('currentMenu');
         $('header.site-header > .mega-menu-section-wrapper[data-dropdown=' + dataDropdown + ']').addClass('currentMenu');
         $('header.site-header > .mega-menu-section-wrapper[data-dropdown=' + dataDropdown + ']').fadeIn( "slow", "linear");
      }
      
    });

    $(document).off("dblclick", "li.mega-menu-list-item > a");

    /* hide the menu when the user scrolls down. */    
    $(window).scroll(function(){
      // checks if the scroll from the top of the screen is greater than the height of the tallest menu plus the height of the header above the menu. This gets us the total height needed for scrolling to the bottom of the navigation menu so it fades out at the right time. 
      // menu1 is the SHOP menu -- 200px of height was added because we weren't grabbing the correct hieght for some reason
      var menu1 = $('.mega-menu-section-wrapper:not(.mega-menu-3)').innerHeight() + 200;
      // menu2 is the ABOUT menu
      var menu2 = $('.mega-menu-section-wrapper + div').innerHeight();
      // menu3 is the TRADE menu
      var menu3 = $('.mega-menu-section-wrapper.mega-menu-3').innerHeight();
      // this puts all of our menus in an array for easy access
      var menus = [menu1, menu2, menu3];
      // determines what the tallest menu is of all three
      var tallestMenu = Math.max.apply(Math.max, menus);       
      // sets the total height of the menu and header based on the tallest menu and the height of the header. We're adding 100 pixels to help cover any odd use cases and give us a little margin - also helps fix weird issues with the SHOP menu
      var heightOfMenuAndHeader = tallestMenu + $('.header__wrapper').innerHeight() + 100;
      // checks our scroll from the top of the page to see if its greater than the hieght of the expanded menu and header
      if ($(window).scrollTop() >= heightOfMenuAndHeader) {          
         // fades out the menu
         $('body').find('.mega-menu-section-wrapper').fadeOut( "fast", "linear");
      }
    });    

      /* hide the menu when the user clicks on the main content of the page or the footer.*/
    $('.main-content, #shopify-section-footer').on('click', function(e) {
      $('body').find('.mega-menu-section-wrapper').fadeOut( "fast", "linear");
    });    

    $('.h4.header-logo').on('click', function(e) {
      e = window.event || e;

      if (e.target === this) {
       	var dataDropdown = $(this).data('dropdown-rel');
      $('body').find('.mega-menu-section-wrapper').fadeOut( "fast", "linear");  
      }
    });

  });
})(window, jQuery)

// Cart Notification show immediately after clicking Add To Cart
let erikaAddToCart = document.querySelector('button[data-add-to-cart]');
let cartNotification = document.querySelector('span.header-cart__bubble');

if(typeof(erikaAddToCart) != 'undefined' && erikaAddToCart != null){
	erikaAddToCart.addEventListener("click", function() {
      cartNotification.style.display = 'block';
    });
}

var optName;
  var inStock;
  var mto;

/*Add Teil Pillows list to navigation*/
$( document ).ready(function() {
 $('.site-header a[href*="/collections/teil-emp-pillows"]').parent().append('<ul><li><a href="/collections/teil-emp-pillows/Teil-Throw-Pillow">Throw Pillows</a></li><li><a href="/collections/teil-emp-pillows/Teil-Bolster-Pillow">Bolsters</a></li><li><a href="/collections/teil-emp-pillows/Teil-Lumbar-Pillow">Lumbars</a></li></ul>');
});

/*var to select all Teil pages*/
var teilTextilesProductPages = $('body#dragon-fruit-cabana-stripe , body#dragon-fruit-beach , body#dragon-fruit-dotted-stripe , body#honeydew-shark-bite , body#honeydew-beach , body#honeydew-waves , body#berry-beach , body#dotty-berry , body#ditsy-berry');
var teilGrassclothProductPages = $('body#dragon-fruit-beach-grasscloth , body#honewdew-beach-grasscloth , body#honeydew-beach-grasscloth , body#berry-beach-grasscloth , body#ditsy-berry');
var teilPillowProductPages = 'body#teil-pillow-variant-test , body#dragon-fruit-beach-throw-pillow , body#dragon-fruit-beach-lumbar , body#dragon-fruit-beach-bolster , body#dragon-fruit-dotted-stripe-throw-pillow , body#dragon-fruit-cabana-stripe-throw-pillow , body#honeydew-beach-throw-pillow , body#honeydew-beach-lumbar , body#honeydew-beach-bolster , body#honeydew-waves-throw-pillow-1 , body#honeydew-shark-bite-throw-pillow , body#honeydew-waves-throw-pillow , body#berry-beach-throw-pillow , body#berry-beach-lumbar , body#berry-beach-bolster , body#ditsy-berry-throw-pillow , body#dotty-berry-throw-pillow';

if (teilTextilesProductPages.length || teilGrassclothProductPages.length) { 
  console.log('teil page');
  $('form .selector-wrapper').addClass('hide');
}

/*Order of vars is Teil Textiles, then Teil Grasscloth, then Teil Pillows*/
  /*
  Textiles products in order of appearance in vars below:
  dragon-fruit-cabana-stripe
  dragon-fruit-beach
  dragon-fruit-dotted-stripe
  honeydew-shark-bite
  honeydew-beach
  honeydew-waves
  berry-beach
  dotty-berry
  ditsy-berry
  */
  
var teilProductsSingleOptionSelectorTextiles = "#dragon-fruit-cabana-stripe .single-option-selector , #dragon-fruit-beach .single-option-selector , #dragon-fruit-dotted-stripe .single-option-selector , #honeydew-shark-bite .single-option-selector , #honeydew-beach .single-option-selector , #honeydew-waves .single-option-selector , #berry-beach .single-option-selector , #dotty-berry .single-option-selector , #ditsy-berry .single-option-selector";
var teilProductsProductFormVariantsTextiles = "#dragon-fruit-cabana-stripe .product-form__variants option , #dragon-fruit-beach .product-form__variants option , #dragon-fruit-dotted-stripe .product-form__variants option , #honeydew-shark-bite .product-form__variants option , #honeydew-beach .product-form__variants option , #honeydew-waves .product-form__variants option , #berry-beach .product-form__variants option , #dotty-berry .product-form__variants option , #ditsy-berry .product-form__variants option";

  /* Teil Grasscloth products */
  /*
  Grasscloth products in order of appearance in the vars below:
  dragon-fruit-beach-grasscloth
  honewdew-beach-grasscloth
  honeydew-beach-grasscloth
  berry-beach-grasscloth
  ditsy-berry
  */

var teilProductsSingleOptionSelectorGrasscloth = "#dragon-fruit-beach-grasscloth .single-option-selector , #honewdew-beach-grasscloth .single-option-selector , #honeydew-beach-grasscloth .single-option-selector , #berry-beach-grasscloth .single-option-selector , #ditsy-berry .single-option-selector";
var teilProductsProductFormVariantsGrasscloth = "#dragon-fruit-beach-grasscloth .product-form__variants option , #honewdew-beach-grasscloth .product-form__variants option , #honeydew-beach-grasscloth .product-form__variants option , #berry-beach-grasscloth .product-form__variants option , #ditsy-berry .product-form__variants option";  

  /* Teil Pillow products */
  /*
  Pillow products in order of appearance in the vars below:
  teil-pillow-variant-test
  dragon-fruit-beach-throw-pillow
  dragon-fruit-beach-lumbar
  dragon-fruit-beach-bolster
  dragon-fruit-dotted-stripe-throw-pillow
  dragon-fruit-cabana-stripe-throw-pillow
  honeydew-beach-throw-pillow
  honeydew-beach-lumbar
  honeydew-beach-bolster
  honeydew-waves-throw-pillow-1
  honeydew-shark-bite-throw-pillow
  honeydew-waves-throw-pillow
  berry-beach-throw-pillow
  berry-beach-lumbar
  berry-beach-bolster
  ditsy-berry-throw-pillow
  dotty-berry-throw-pillow
  */

var teilProductsSingleOptionSelectorPillows = "#teil-pillow-variant-test .single-option-selector , #dragon-fruit-beach-throw-pillow .single-option-selector , #dragon-fruit-beach-lumbar .single-option-selector , #dragon-fruit-beach-bolster .single-option-selector , #dragon-fruit-dotted-stripe-throw-pillow .single-option-selector , #dragon-fruit-cabana-stripe-throw-pillow .single-option-selector , #honeydew-beach-throw-pillow .single-option-selector , #honeydew-beach-lumbar .single-option-selector , #honeydew-beach-bolster .single-option-selector , #honeydew-waves-throw-pillow-1 .single-option-selector , #honeydew-shark-bite-throw-pillow .single-option-selector , #honeydew-waves-throw-pillow .single-option-selector , #berry-beach-throw-pillow .single-option-selector , #berry-beach-lumbar .single-option-selector , #berry-beach-bolster .single-option-selector , #ditsy-berry-throw-pillow .single-option-selector , #dotty-berry-throw-pillow .single-option-selector";
var teilProductsProductFormVariantsPillows = "#teil-pillow-variant-test .product-form__variants option , #dragon-fruit-beach-throw-pillow .product-form__variants option , #dragon-fruit-beach-lumbar .product-form__variants option , #dragon-fruit-beach-bolster .product-form__variants option , #dragon-fruit-dotted-stripe-throw-pillow .product-form__variants option , #dragon-fruit-cabana-stripe-throw-pillow .single-option-selector , #honeydew-beach-throw-pillow .single-option-selector , #honeydew-beach-lumbar .single-option-selector , #honeydew-beach-bolster .single-option-selector , #honeydew-waves-throw-pillow-1 .single-option-selector , #honeydew-shark-bite-throw-pillow .single-option-selector , #honeydew-waves-throw-pillow .single-option-selector , #berry-beach-throw-pillow .single-option-selector , #berry-beach-lumbar .single-option-selector , #berry-beach-bolster .single-option-selector , #ditsy-berry-throw-pillow .single-option-selector , #dotty-berry-throw-pillow .single-option-selector";  

function updateVariantType(){  
  
  console.log('we here - updateVariantType()');
      
       var currQty = $('.quantity__input').val();
  console.log("Current Quantity: " + currQty);
  var variantName = '';

/*The ":not" portion of the code is the reason that Teil products are not registering values correctly. The optName variable has a value of "availability" for all products, but the HTML has different values for the "data-option-name=" field. 
This function is not working because "date-option-name" is not being selected because the HTML of Teil products has "data-option-name=availability". The "not:" portion of this code may be unnecessary but I don't want to risk it.*/

/* Added code here for Porch Perfect Pillow as well. - This is not a good practice but just moving quick to get this out the door - 8/21/24 - Andrew*/

  $('.single-option-selector:not([data-option-name="'+ optName +'"]) , '+ teilProductsSingleOptionSelectorTextiles +' , '+ teilProductsSingleOptionSelectorGrasscloth +' , '+ teilProductsSingleOptionSelectorPillows +'').each(function(){
  console.log('looping');
    if(variantName.length > 0){
    variantName = variantName + ' / ' + $(this).val();
    }
    else{
      variantName = $(this).val();
    }
  });
  
 if(variantName?.length > 0){
    variantName = variantName + ' / ' + 'in stock';
    }
    else{
      variantName = 'in stock';
    }
  variantName = variantName.toLowerCase();
  console.log('variantName:' + variantName);

  /*if product variants aren't added, then this if statement won't fire. */
  // if($('.product-form__variants option[data-name="'+variantName+'"] , '+ teilProductsProductFormVariantsTextiles +' , '+ teilProductsProductFormVariantsGrasscloth +' , '+ teilProductsProductFormVariantsPillows +'').length > 0){
  //   console.log("entered if statement");
  //   var availQty = $('.product-form__variants option[data-name="'+variantName+'"] , '+ teilProductsProductFormVariantsTextiles +' , '+ teilProductsProductFormVariantsGrasscloth +' , '+ teilProductsProductFormVariantsPillows +'').data('qty');
 
  //    console.log('currQty: ' + currQty + '; availQty:' + availQty);
 
  
  //      if(currQty > availQty){
         
  //        $('.single-option-selector[data-option-name="availability"] , '+ teilProductsSingleOptionSelectorTextiles +' , '+ teilProductsSingleOptionSelectorGrasscloth +' , '+ teilProductsSingleOptionSelectorPillows +'').val('Made to order');
         
  //      }
  //      else{
  //        $('.single-option-selector[data-option-name="availability"] , '+ teilProductsSingleOptionSelectorTextiles +' , '+ teilProductsSingleOptionSelectorGrasscloth +' , '+ teilProductsSingleOptionSelectorPillows +'').val('In stock');
  //        console.log("else - in stock");
  //      }
       
  //      $('.single-option-selector[data-option-name="availability"] , '+ teilProductsSingleOptionSelectorTextiles +' , '+ teilProductsSingleOptionSelectorGrasscloth +' , '+ teilProductsSingleOptionSelectorPillows +'').trigger('change');
       
  //      console.log('new value: ' + $('.single-option-selector[data-option-name="availability"] , '+ teilProductsSingleOptionSelectorTextiles +' , '+ teilProductsSingleOptionSelectorGrasscloth +' , '+ teilProductsSingleOptionSelectorPillows +'').val());
  //  }
  // else{
  //   console.log('no such variant');
  // }
}

$(document).ready(function(){
  optName = $('body').data('avail-option');
  inStock = $('body').data('in-stock');
  mto = $('body').data('mto');
 
  
  $(document).on('input','.has-avail-opt .quantity__input', function(){
    updateVariantType();
  })
  
  $('.has-avail-opt .single-option-selector:not([data-option-name="'+ optName +'"])').change(function(){
    updateVariantType();
  })
  
})



/* cart drawer price update and checkout button removal */

/* This code activates on the add to cart button click from the product page when someone is logged into the wholesale Portal. */

/* This is necessary because the Cart Drawer uses ajax, and it is not set to work by default with the Wholesale Club App. This 
   makes the price update and hides the direct checkout button so user can only go to the cart. If a user could go straight to 
   checkout the wholesale discounts would not apply. */
  
$( document ).ready(function() {
  productValue = $('.wholesale-customer .product__price > span.money > span > span').text();

  // updates the product value when a customer changes the options of the product, like changing the size of a pillow and the 
  // price needs to change with it.
  $(".selector-wrapper select").on( "click", function() {
      // updates the product value
      productValue = $('.wholesale-customer .product__price > span.money > span > span').text();
  });
  
/* selects button clicks on the product page for add to cart */  
  $( ".wholesale-customer .product-page button.addToCart:not(#AddToCart-Buy-A-Swatch)" ).on( "click", function() {
    console.log('button clicked');

    (function() {
      var func = function() {

           /* Updates product pricing for wholesale portal customers on the cart drawer. */
           $(".wholesale-customer .cart-drawer .product__add__details p:last-of-type()").replaceWith('<p>' + productValue + '</p>' );

           /* Hides the checkout button on the cart drawer when a wholesale portal customer is logged in - this is necessary for the discounts to properly work. */
           $(".wholesale-customer .cart-drawer .product__add__buttons a[href*='checkout']").css('display' , 'none'); 

      }
      setTimeout(func, 400);
      setTimeout(func, 800);
      setTimeout(func, 1200);    
      setTimeout(func, 1600);      
    })();
    
  });

  /* selects button clicks on the product page for buy a swatch */  
  $( ".wholesale-customer .product-page button.addToCart#AddToCart-Buy-A-Swatch" ).on( "click", function() {
    console.log('button clicked');

    (function() {
      var func = function() {

           /* Updates product pricing for wholesale portal customers on the cart drawer. */
           $(".wholesale-customer .cart-drawer .product__add__details p:last-of-type()").replaceWith('<p>$0</p>' );

      }
      setTimeout(func, 400);
      setTimeout(func, 800);
      setTimeout(func, 1200);    
      setTimeout(func, 1600);      
    })();
    
  });

});

/* This moves the cut fee over above the subtotal */
$( document ).ready(function() {

    (function() {
      var func = function() {
  $(".wholesale-customer .cart__footer .grid__item.large--one-half > .mw-stack").detach().prependTo('.wholesale-customer .cart__footer .grid__item.large--one-half.text-right');

      }
      setTimeout(func, 0);
      setTimeout(func, 50);
      setTimeout(func, 100);
      setTimeout(func, 200);    
      setTimeout(func, 400);      
      setTimeout(func, 800);     
      setTimeout(func, 1600);     
    })();
  
});


/* Remove Swatch pricing for trade customers - not Showroom Designer Profile (because they still have to pay regular price for Swatches) */

// the text will disappear or appear based on the type of customer who is present, and what text is present.
$( document ).ready(function() {

    // selects the swatch product page, product description section, where it says the swatch price.
    $('.wholesale-customer:not(.showroom-designer-pro) .product-page .product-single .product-description :contains("$4 / swatch")').each(function(){
        $(this).html($(this).html().split("$4 / swatch").join(""));
    });
  
    // selects the swatch product page, product description section, where it says the swatch price.  
    $('.wholesale-customer:not(.showroom-designer-pro) .product-page .product-single .product-description :contains("$5 / swatch")').each(function(){
        $(this).html($(this).html().split("$5 / swatch").join(""));
    });

});



/* Redirects Showroom Designers giving them instructions */

// adds a cookie if the showroom designer is here.
$(document).ready(function() {

    // Loads the cookie in the backend but does not set a cookie on the browser yet. This is the backend code for the cookie. The cookie is called later in the If statement.

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {   
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }  

    // checks to see if the logged in user is a Showroom Designer.
    if ($("body").hasClass("showroom-designer-pro")) {

        console.log('has showroom-designer-pro class');    
      
        // Adds the cookie to show or hide the popup. Cookie expires in 1 day.
        // makes everything wait until a few seconds after the page is fully loaded.

        // checks to see if the cookie is already present
        var x = getCookie('ShowroomDesignerProfileCookie');
        if (x) {
            // does not redirect if the cookie is present
            console.log('in the if statement - cookie exists, do not redirect showroom designer');              
        }
        else {
            // sets the cookie and shows the popup
            setCookie('ShowroomDesignerProfileCookie','PopupCookie',1);

            // redirects the showroom designer to the showroom designer landing page
            // var url = "https://www.erikampowell.com/pages/showroom-designer-landing-page";
            // $(location).attr('href',url);

          
        } // end else statement
          
  
    } // end if statement - if showroom designer profile

  
}); // end document.ready




/* Redirects All users to choose Retail or Trade  */

/* HIDE Function - Redirect All Users to Choose Retail or Trade

// adds a cookie if the user is here.
$(document).ready(function() {
    console.log("in the function");

    // Loads the cookie in the backend but does not set a cookie on the browser yet. This is the backend code for the cookie. The cookie is called later in the If statement.

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {   
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }  

    // checks to see if the logged in user is a Trade Portal Customer.
    if ($("body").hasClass("wholesale-customer") || $("#trade-portal-registration").length ) {
        
        // sets the cookie so they don't have to see the "Trade or Retail" Page
        setCookie('AllUsersCookie','PopupCookie',1);
    }

    // the user is not logged in or is not a Trade Portal Customer
    else {
        console.log('has wholesale-customer class');    
      
        // Adds the cookie to show or hide the popup. Cookie expires in 1 day.
        // makes everything wait until a few seconds after the page is fully loaded.

        // checks to see if the cookie is already present
        var x = getCookie('AllUsersCookie');
        if (x) {
            // does not redirect if the cookie is present
            console.log('in the if statement - cookie exists, do not redirect user');              
        }
        else {
            // sets the cookie and shows the popup
            setCookie('AllUsersCookie','PopupCookie',1);

            // if user is in the admin of the site then do nothing 
            if (window.location.href.indexOf("erikampowell.myshopify.com") > -1) {
                console.log("do not show retail or trade page");
            }

            // if user is not in the admin of the site then activate the cookies and retail or trade landing page    
            else {
                // redirects the user to the retail or trade landing page
                var url = "https://www.erikampowell.com/pages/retail-or-trade-landing-page";
                $(location).attr('href',url);

            } // end else statement - if user is not in the admin of the site then activate the cookies and retail or trade landing page  

          
        } // end else statement
          
  
    } // end else statement - the user is not logged in or is not a Trade Portal Customer
         
}); // end document.ready

*/ // End of HIDE Function - Redirect All Users to Choose Retail or Trade


/* Trade Portal Showroom Designer Profile - Change Add To Cart Button Text */
$(document).ready(function() {
  
    // only applies to Showroom Designer Profile
    if ($('body.showroom-designer-pro').length) {
      
        // Selects the breadcrumbs on the correstponding product pages for Fabric, Grasscloth, and Swatches
        if($('nav.breadcrumb > *:contains(PILLOW) , nav.breadcrumb > *:contains(Pillow) , nav.breadcrumb > *:contains(LUMBAR) , nav.breadcrumb > *:contains(Lumbar) , nav.breadcrumb > *:contains(BOLSTER) , nav.breadcrumb > *:contains(Bolster)').length) {

        }

        // runs the else statemen when the pillows are not selected
        else {
          

            // Let's us know what products it is selecting
            console.log('Wholesale Designer Not Purchasable');

            // replaces contents of the Add to Cart Button with the appropriate text and removes pointer events using inline styles
            // $('.add-to-cart__wrapper button').replaceWith('<button type="submit" name="add" data-add-to-cart="" class="btn btn--large btn--full btn--clear uppercase addToCart" style="pointer-events: none;">Kindly Contact Your Showroom</button>');
                        // @lifeblue v1.1.12 | Duplicate Btn | I have removed the old code that replaced any button in the add to cart wrapper with the "Kindly Contact Your Showroom" text, and disabled pointer events.
            // (Because there was both an "Add to Cart" and a "Buy a Swatch" btn, they were both getting replaced and so it looked like a duplicate; and the buttons didn't do anything).
            // Instead, I am hiding the buttons and creating a new one that will link to the /pages/representation page, per client request. 
            console.log('hiding!')
              $('.add-to-cart__wrapper button').hide();

              const newButton = $('<a>', {
                  href: '/pages/representation',
                  class: 'btn btn--large btn--full btn--clear uppercase no-style',
                  text: 'Kindly Contact Your Showroom'
              });

              $('.add-to-cart__wrapper').append(newButton);

            // Disable the form from sending
            $("form.shopify-product-form").attr("disabled", true);
            $("input.text quantity.js-qty__num.quantity__input").attr("disabled", true);

            // keep button text the same when quantity is changed on click
          	$('.js-qty.quantity-selector').click(function(){
        		$('.add-to-cart__wrapper button').text("Kindly Contact Your Showroom");
        	});
        }
    }

});

/* Cart Accordion Function */

jQuery(document).ready(function(){
    // starts the accordion off as closed.
    $('.OTMaccordionContent').css('display' , 'none'); 

    // toggles accordion back and forth
	jQuery('.OTMaccordionTitle').click(function(){
		jQuery(this).siblings('.OTMaccordionContent').slideToggle();
		jQuery(this).toggleClass('contentOpen');
	});
});



/* Cart Order Notes Change Placeholder Text */
jQuery(document).ready(function(){
   $("body:not('.wholesale-customer') #CartSpecialInstructions").attr('placeholder', 'If you have general order notes or have purchased a custom item(s) in need of pattern/colorway specification, please drop those details for us here!');  
   $("body.wholesale-customer #CartSpecialInstructions").attr('placeholder', 'Please write any specific notes about your order here ie: PO#, sidemark, yardage increments, shipping/delivery notes, etc.');    
}); 


/* Net Terms change the checkout button text */
jQuery(document).ready(function(){
   $("body.wholesale-customer.net15 .checkout__button, body.wholesale-customer.net30 .checkout__button, body.wholesale-customer.net45 .checkout__button, body.wholesale-customer.net60 .checkout__button").attr("value" , "Pay By Card"); 
});

/* Product page hide the buy a swatch button when Showroom Designer Profile is logged in */
jQuery(document).ready(function(){

    // The following lines hide the swatch button in different layouts of the product pages. It is not using the same html each time.

    // hides products with formats like on this product page: https://www.erikampowell.com/collections/grasscloth/products/artichoke-grasscloth-hideprod
    $(".showroom-designer-pro .product-page a[href*='swatch']").hide();

    // hides products with formats like on this product page: https://www.erikampowell.com/collections/teil-emp-textiles/products/dragon-fruit-beach
    $(".showroom-designer-pro .product-page .grid__item.large--one-third .product__form + + form").hide();

    // hides products with formats like on this product page: https://www.erikampowell.com/collections/teil-emp-pillows/products/dragon-fruit-dotted-stripe-throw-pillow
    $(".showroom-designer-pro .product-page .grid__item.large--one-third > form").hide();
});

/* adds css classes to the Pay By Check Button */
jQuery(document).ready(function(){
$(".rte.clearfix .purchase-benefits.button.btn.btn--red.btn-primary.button--primary.btn-lg.solid.action-button.action_button.submit.cart-checkout-button.cart__checkout").addClass("btn uppercase btn--large btn--splash checkout__button");
});


/* Account page showing and hiding the Trade and Retail Login options */
jQuery(document).ready(function(){
    if (('#account').length > 0) {
        $('#account-page-select-retail-or-trade').on( "change", function() {    
            if ($('#account-page-select-retail-or-trade option[value="retail"]').is(':selected')) { 
                $('.retail-login').show();
                $('.trade-login').hide();
            }
            else if ($('#account-page-select-retail-or-trade option[value="trade"]').is(':selected')) { 
                console.log('we made it 4');
                $('.retail-login').hide();
                $('.trade-login').show();
            }
        })

        /* make the Trade Reset Password Password button toggle the password reset form on and off */  
        $("#RecoverPassword_Trade").on( "click", function() {
            console.log('clicked Trade Login Forgot Password');

            /* if customer login form is visible then hide it */  
            if($('.trade-login #CustomerLoginForm:visible').length == 0) {
                $(".trade-login #CustomerLoginForm").hide();    
                $(".trade-login #RecoverPasswordForm_Trade").show();  
            }      
            
        });

        /* when customer is in the Trade view and they have already clicked on forgot password, then they decide to cancel their action , this code make the regular Trade customer login form visible again. */
       $(".trade-login #HideRecoverPasswordLink_Trade").on( "click", function() {
          console.log('clicked Trade Login Cancel Forgot Password');

                $(".trade-login #CustomerLoginForm").show();    
                $(".trade-login #RecoverPasswordForm_Trade").hide();  
              

        });
      
    }
});

/* shows the retail login on page load , not showing the reset password page by default for retail*/
jQuery(document).ready(function(){
    $(".retail-login #CustomerLoginForm").show();
    $(".retail-login #RecoverPasswordForm").hide();
});


/* Retail or Trade Landing Page */

/* Replace the header logo with a bigger one that doesn't pixelate */

$('#retail-or-trade-landing-page .site-header .header-logo a').replaceWith('<a><img src="https://cdn.shopify.com/s/files/1/1637/4787/files/emp_logo.jpg?v=1698252030" class="logo--color" srcset="https://cdn.shopify.com/s/files/1/1637/4787/files/emp_logo.jpg?v=1698252030 1x, https://cdn.shopify.com/s/files/1/1637/4787/files/emp_logo.jpg?v=1698252030 2x" alt="Erika M. Powell Textiles"></a>'); 




// Stockings page image sizing
$(document).ready(function(){  // getting started

  
  if($('body#erika-m-powell-textiles-stockings.template-collection').length) { // understanding if we're on the right page
    console.log("we're here - stockings page");

    // Petite Cross Bone Stocking
    if ($('a[href="/collections/stockings/products/petite-cross-dot-bone-stocking"]')) { 
      console.log('were here petite-cross-dot-bone-stocking');
      $('a[href="/collections/stockings/products/petite-cross-dot-bone-stocking"] img').attr("src", "https://cdn.shopify.com/s/files/1/1637/4787/products/fullsizeoutput_13145_720x.jpg?v=1667420908");
    }

    // Arrowhead Relief Moss Stocking
    if ($('a[href="/collections/stockings/products/arrowhead-relief-moss-stocking"]')) { 
      console.log('were here arrowhead-relief-moss-stocking');
      $('a[href="/collections/stockings/products/arrowhead-relief-moss-stocking"] img').attr("src", "https://cdn.shopify.com/s/files/1/1637/4787/products/fullsizeoutput_13159_720x.jpg?v=1667426066");
    }    

    // Leaf In Grove Stocking
    if ($('a[href="/collections/stockings/products/leaf-in-grove-stocking"]')) { 
      console.log('were here leaf-in-grove-stocking');
      $('a[href="/collections/stockings/products/leaf-in-grove-stocking"] img').attr("src", "https://cdn.shopify.com/s/files/1/1637/4787/products/PCDGroveStocking_720x.jpg?v=1667940017");
    }        

    // Happy Happy Sage Stocking
    if ($('a[href="/collections/stockings/products/happy-happy-sage-stocking"]')) { 
      console.log('were here happy-happy-sage-stocking');
      $('a[href="/collections/stockings/products/happy-happy-sage-stocking"] img').attr("src", "https://cdn.shopify.com/s/files/1/1637/4787/products/fullsizeoutput_13140_720x.jpg?v=1667420336");
    }         

    // Gerty's Dot Bone Stocking
    if ($('a[href="/collections/stockings/products/gertys-dot-bone-stocking"]')) { 
      console.log('were here gertys-dot-bone-stocking');
      $('a[href="/collections/stockings/products/gertys-dot-bone-stocking"] img').attr("src", "https://cdn.shopify.com/s/files/1/1637/4787/products/fullsizeoutput_1314d_720x.jpg?v=1667425267");
    }            

    // Oh My Stars Mineral Stocking
    if ($('a[href="/collections/stockings/products/oh-my-stars-mineral-stocking"]')) { 
      console.log('were here oh-my-stars-mineral-stocking');
      $('a[href="/collections/stockings/products/oh-my-stars-mineral-stocking"] img').attr("src", "https://cdn.shopify.com/s/files/1/1637/4787/products/fullsizeoutput_133d8_720x.jpg?v=1668102146");
    }                
    
  }
})



// No variant products image carousel arrow functionality
$(document).ready(function(){  // getting started

  // select only one page for now for testing.
  // if($('body#oh-my-stars-mineral-stocking').length) { // understanding if we're on the right page
    // console.log("we're here - no variant product page - only oh-my-stars-mineral-stocking");

    // 1. SELECT NO-VARIANT PAGES
    if ($('select.product-form__variants').children().length <= 1) {

      
      if(typeof variant == 'undefined') {
        console.log('variant variable undefined');
      }
      else if (variant.inventory_policy == 'deny') {
        console.log('were here - deny');
  
      // 2. SELECT ARROWS
       var nextArrowClick = $('.product-single .slick-next');
       var previousArrowClick = $('.product-single .slick-prev');
        
      // 3. UNBIND EXISTING CLICK EVENTS
      nextArrowClick.off();
      previousArrowClick.off();  
        
      // 4. ADD ACTIVE CLASS ON CLICK
      // 5. REMOVE ACTIVE CLASS ON CLICK
  
        // define current image and next image.
        var currentImage = $('.slick-track .slick-active');
        var nextImage = currentImage.next();
  
        var currentImageWidth = currentImage.width();
        console.log(currentImageWidth);
        
        var currentSlickTrackWidth = $('.slick-track').width();
        var currentSlickTrackWidthMinus2Negative = (currentSlickTrackWidth - (currentImageWidth * 2)) * -1;
        console.log('current Slick Track Width Minus 2: ' + currentSlickTrackWidthMinus2Negative);
        
        var initialSlickTrackPosition = 0 - currentImageWidth;
        console.log("initial slick track position: " + initialSlickTrackPosition);
  
        var currentImagePosition = initialSlickTrackPosition;
        
        var currentSlickTrackStartingPosition = 0 - currentImageWidth;
        console.log("current slick track starting position: " + currentSlickTrackStartingPosition);
  
        var nextPosition = currentSlickTrackStartingPosition - currentImageWidth;
        console.log('next position: ' + nextPosition);
  
        var previousPosition = currentSlickTrackWidthMinus2Negative;
        console.log('previous position: ' + previousPosition);
  
        function clickVariableUpdate(){
          currentImageWidth = currentImage.width();
          currentSlickTrackWidth = $('.slick-track').width();
          currentSlickTrackWidthMinus2Negative = (currentSlickTrackWidth - (currentImageWidth * 2)) * -1;
          currentSlickTrackStartingPosition = 0 - currentImageWidth;
        };
  
        function resetVariablesToInitial() {
          currentImagePosition = 0 - currentImageWidth;
          previousPosition = currentSlickTrackWidthMinus2Negative;
          nextPosition = currentImagePosition - currentImageWidth;
          console.log('reset variables to initial');
          console.log('current position: ' + currentImagePosition);
          console.log('next position: ' + nextPosition);
          console.log('previous position: ' + previousPosition);
        }
  
        function resetVariablesToLast() {
          currentImagePosition = currentSlickTrackWidthMinus2Negative;
          previousPosition = currentSlickTrackWidthMinus2Negative + currentImageWidth;
          nextPosition = 0 - currentImageWidth;
          console.log('reset variables to last');
          console.log('current position: ' + currentImagePosition);
          console.log('next position: ' + nextPosition);
          console.log('previous position: ' + previousPosition);        
        }
  
  
        var resizeTimer;
  
        $(window).on('resize', function(e) {
        
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
        
            // Run code here, resizing has "stopped"
                console.log('resized');
                clickVariableUpdate();
                resetVariablesToInitial();
                    
          }, 250);
        
        });
        
  
  
        
        // click function nextArrowClick
        nextArrowClick.click(function() {
  
          console.log( "Handler for .click() next position called." );
          
          clickVariableUpdate();       
  
          // MAKE THE SLIDE HAPPEN    
          
          // CLICKING NEXT
          $('.slick-track').css({
              "transition-duration" : "500ms" ,
              'transform' : 'translateX(' + nextPosition +'px' + ')'
              });
  
          
          // if at end of carousel then go back to first image.
          if (currentSlickTrackWidthMinus2Negative >= nextPosition) {
            console.log("we're here next position equals slick track width");
            
            currentImagePosition = currentSlickTrackWidthMinus2Negative;
            console.log('current position: ' + currentImagePosition);
            
            // go to starting position - image 1
            nextPosition = currentSlickTrackStartingPosition;
            console.log('next position: ' + nextPosition);
  
            // go to second to last image
            previousPosition = currentSlickTrackWidthMinus2Negative + currentImageWidth;
            console.log('previous position: ' + previousPosition);
            
          }
  
          else if (currentImagePosition <= currentSlickTrackWidthMinus2Negative) {
            resetVariablesToInitial();
    
          }
            
          // next position in any position other than the last image or first image  
          else {
            console.log("we're here next position DOES NOT equal slick track width");
  
            currentImagePosition = (currentImagePosition - currentImageWidth);
            console.log('current position: ' + currentImagePosition);
            
            // go to next image
            nextPosition = nextPosition - currentImageWidth;
            console.log('next position: ' + nextPosition);  
  
            // go previous 1 image
            previousPosition = nextPosition + (currentImageWidth *2);
            console.log('previous position: ' + previousPosition);  
  
            // if current image position is huge reset all variables back to 1st image
            if (currentImagePosition <= (currentSlickTrackWidthMinus2Negative - currentImageWidth)) {
              currentImagePosition = currentSlickTrackStartingPosition;
  
            }
            
          }
          
        });
  
  
        // click function previousArrowClick
        previousArrowClick.click(function() {
  
          console.log( "Handler for .click() previous position called." );
          
          clickVariableUpdate();
  
          // MAKE THE SLIDE HAPPEN    
          
          // going PREVIOUS
          $('.slick-track').css({
              "transition-duration" : "500ms" ,
              'transform' : 'translateX(' + previousPosition +'px' + ')'
              });
  
  
          // if at start of carousel then go to last image.
          if (initialSlickTrackPosition <= previousPosition) {
            console.log("we're here previous position equals initial slick track position");
  
            resetVariablesToInitial();
            
            // go to end of carousel
            // previousPosition = currentSlickTrackWidthMinus2Negative;
            // console.log('previous position: ' + previousPosition);
  
            // go to next image
            // nextPosition = currentSlickTrackStartingPosition - currentImageWidth;
            // console.log('next position: ' + nextPosition); 
            
          }
  
          // if previous button clicked and in the last image position  
          else if (previousPosition <= currentSlickTrackWidthMinus2Negative) {
            resetVariablesToLast();
          }
            
          // if in any position other than the 1st image in the carousel  
          else {
            console.log("we're here previous position DOES NOT equal initial slick track position");
  
            currentImagePosition = (currentImagePosition + currentImageWidth);
            console.log('current position: ' + currentImagePosition);
  
            // go to next image
            nextPosition = nextPosition + currentImageWidth;
            console.log('next position: ' + nextPosition); 
            
            // go to previous image
            previousPosition = previousPosition + currentImageWidth;
            console.log('previous position: ' + previousPosition);  
  
          }
  
            // resets nextPosition if getting "off track." The nextPosition never needs to be zero.
            if (nextPosition >= 0) {
              nextPosition = (currentSlickTrackWidthMinus2Negative);
            } 
          
        });
      
  
      // 6. THUMBNAILS  
  
       // select product thumbnails
       var productThumbnails = $('.product__thumbs--square .slick-dots li');
  
       // unbind click event 
       productThumbnails.off();
  
        // declare imagePosition variable -- to be changed on click.
        var imagePosition = 0;
  
        // run for loop over product thumbnails, assigning a number to each in the index, starting with zero, and applying a click function to scroll to each of them, while also reseting the product arrow selection buttons as needed so both types of click functions are in sync.
        
        // run for loop
        productThumbnails.each(function( index ) {
          
          // log how many thumbnails are in the index
          console.log( index + ": " + $( this ).text() );
  
          // get number of thumbnails
          var numberOfImages = productThumbnails.length;
          
          // log number of images
          console.log('number of images: ' + numberOfImages);
  
          // click function run on each element of the array produced by the for loop (jQuery .each() statement above).
          $( this ).click(function() {
  
            // verify click iteration works
            console.log( index + " clicked");
  
            // update vars on click for screen width - make sure sizing is correct according to screen width changes. Determined on click.
            clickVariableUpdate();
  
            // set var imagePosition to the correct thumbnail being clicked.
            imagePosition = ((currentImageWidth * index * -1) - currentImageWidth);
            
              // tell slick track where to scroll
              $('.slick-track').css({
                "transition-duration" : "500ms" ,
                'transform' : 'translateX(' + imagePosition +'px' + ')'
              });
  
            // for each thumbnail that's clicked, adjust the other variables used in the arrows.
            resetVariablesToInitial();
            // update variables
  
            currentPosition = (((currentImageWidth * index) + currentImageWidth) * -1);
            console.log('thumbnail clicked current position changed to: ' + currentPosition);
  
            nextPosition = (((currentImageWidth * index) + (currentImageWidth * 2)) * -1);
            console.log('thumbnail clicked next position changed to: ' + nextPosition);
            
            previousPosition = ((currentImageWidth * index) * -1);
            console.log('thumbnail clicked previous position changed to: ' + previousPosition);
            
            if (currentPosition >= (currentImageWidth * -1)) {
              resetVariablesToInitial();
            } 
            if (currentPosition <= currentSlickTrackWidthMinus2Negative) {
              resetVariablesToLast();
            }
            
          })
        })
        
      } // end of elseif statement - variant.product == deny
      
      } // end of first if statement - if page has the class. 
                  
  // } // end of if (page equals one specific page)


})

// Hide options on the Cart page unless it's a Wholesale Customer
$(document).ready(function(){  // getting started
  if($('body').hasClass("wholesale-customer") ) {
    $(".cfa-address-section").css("display", "block"); // hides the address section when someone's not a wholesale customer.
  }
  
})

/*------------------Pillow Customization-------------------------
-----------------------------------------------------------------*/
/*$(document).ready(function(){
  //Set timeout function that waits for the easify plugin to load
  setTimeout(function(){
    
        //Create a click event on the variant box container
        $('.tpo_shape_null').click(function(event) {
          replaceImage();
        });
    
        //Function that has the code to replace the current image with the image that correspond to the variant combination selected
        var replaceImage = function() {
          //Variable that gets the value of the variant combination
          var variantCombination = '';
          //Array with the default variant value for each variant
          var variantArr = ['Size-0', 'Pom-0', 'Fringe-0', 'Finish-0'];
          //Array that will have two values inside, the variant name Ex.:'Size' and the variant number Ex:0, and we will use the variant name to check
          //the position in the array we need to change depending on the new variant selection
          var imgIdArr = [];
          //currImg and currImgId will get the image and then the image id from the variant selected
          var currImg;
          var currImgId;
          //We iterate over the variants currently selected
          $(".tpo_is_checked_swatches").each(function() {
            //We get the variant image
            currImg = $(this).find('input')[0];
            //We get the id corresponding to the image
            currImgId = $(currImg).attr('id');
            //We divide the id into the name and number, and we will check later the name
            imgIdArr = currImgId.split('-');
            for(let i = 0; i < variantArr.length; i++) {
              //We check if the current variant value from the default variant combination arr correspond to the same name as the variant selected 
              //so we replace the correct index
              if(variantArr[i].includes(imgIdArr[0])) {
                //Get the index of the default variant combination arr to replace
                var currIndex =  variantArr.indexOf(variantArr[i]);
                //Replace the correct value from the default combination arr
                variantArr[currIndex] = currImgId;
              }
            }
          });
          //Create a string from the new variant combination arr that we will use to get the image from the slider
          variantCombination = variantArr.join('');
          //Find the image we want inside the image slick slider by using the variantCombination
          var imgToShow = $('.product__photo:has(img[alt=' + variantCombination + '])')[0];
          var imgFind = $(imgToShow).find('img[srcset]');
   
          //Get the srcset from the image
          var imgSrcset = $(imgFind)[0];
          var newSrcset = $(imgSrcset).attr('srcset');
          //Target the big preview image
          var currImg = $('.slick-current img')[0];
          //Replace the srcset of the preview image so the variant image is displayed instead
          $(currImg).attr('srcset', newSrcset);
          console.log(currImg);
        }

        //Call the function one time to pre-select the image corresponding to the default combination
        //(Maybe we can delete this call to the function once we have the correct default image being shown in the product page)
        replaceImage();
    
  }, 1000)
})*/


/*------------------Order Notes Fix---------------------
--------------------------------------------------------
-------------------------------------------------------*/

//Alternate option
$(document).ready(function(){
  let path = window.location.pathname;
  if(path === '/cart') {
      if($(".nettermsContainer")[0]) {
           //Add class to style pay by card button
           $('.cart__footer__buttons').addClass('payByCardBtnContainer');
          //Create a fake button BY CARD
          $('.checkout__button:nth-child(1)').after('<div id="fakeCheckoutBtn">PAY BY CARD</div>');
          //Hide real checkout button BY CARD
          $('.checkout__button:nth-child(1)').addClass('hideMe');
          //Create a fake button BY CHECK
          $('.nettermsContainer .checkout__button').after('<div id="fakeCheckoutBtnCheck">PAY BY CHECK</div>');
          //Hide real checkout button BY CHECK
          $('.nettermsContainer .checkout__button').addClass('hideMe');
          //Add pay by card title
          $('#fakeCheckoutBtn').before('<h3>Pay by Card</h3>');
          /*-----------PAY BY CARD Click-----------*/
          //$('#fakeCheckoutBtn').click(function() {
          let buttonPay = document.getElementById('fakeCheckoutBtn');
          buttonPay.addEventListener("click", function() {
            //Click outside the notes
            $('body')[0].click();
            $('body')[0].click();
            //Click the real button
            setTimeout(function(){$('.checkout__button:nth-child(1)')[0].click()}, 500);
            //Change the background color of the checkout button
            $('#fakeCheckoutBtn').css('background-color', '#c4c4c4');
            }, {once : true});
            //Style fake button BY CHECK
            //$('.cart__footer__buttons').children().eq(1).addClass('flexEnd');
            /*-----------PAY BY CHECK Click-----------*/
            //$('#fakeCheckoutBtnCheck').click(function() {
            let buttonCheck = document.getElementById('fakeCheckoutBtnCheck');
            buttonCheck.addEventListener("click", function() {
            //Click outside the notes
            $('body')[0].click();
            $('body')[0].click();
            //Click the real button
            setTimeout(function(){$('.nettermsContainer .checkout__button')[0].click()}, 500);
            //Change the background color of the checkout button
            $('#fakeCheckoutBtnCheck').css('background-color', '#c4c4c4');  
          }, {once : true});
      } else {
          //Create a fake button
          $('.checkout__button').after('<div id="fakeCheckoutBtn">CHECK OUT</div>');
          //Hide real checkout button
          $('.checkout__button').addClass('hideMe');
          //Style fake button
          $('.cart__footer__buttons').children().eq(1).addClass('flexEnd');
          let button = document.getElementById('fakeCheckoutBtn');
          //$('#fakeCheckoutBtn').click(function(event) {
          button?.addEventListener("click", function() {
              //Click outside the notes
              $('body')[0].click();
              $('body')[0].click();
              //Click the real button
              setTimeout(function(){
                $('.checkout__button')[0].click();
                $(this).find('.checkout__button').attr('disabled', 'disabled');
              }, 500);
              //Change the background color of the checkout button
              $('#fakeCheckoutBtn').css('background-color', '#c4c4c4');
          }, {once : true});
      }
  }
});

/*------------Remove default title variant selector---------------*/
$(document).ready(function() {
  //Get the first option from the variant
  var defaultTxt = $('#ProductSelect-product option').first().text();
  //Check if it includes default meaning is the deafult option and hide it
  if(defaultTxt.includes('Default')) {
    $('#ProductSelect-product').css('display', 'none');
  }
});

/*----Hide notify me button for all of the products that are not picnic mats-----*/
$(document).ready(function() {
  //Get the id of the product which is the same as the name of the product
  var navTxt = $('body').attr('id');
  //Hide the notify me button if they are not picnic mats
  if(!navTxt.toString().includes('picnic-mat')) {
      setTimeout(function() {
        $('.gw-button-widget[gw-stock-fulfilled]').css('display','none');
      }, 1000);
  }
});

/*---Style sold-out button on picnic mats----*/
$(document).ready(function() {
  var navTxt = $('body').attr('id');
  if(navTxt.toString().includes('picnic-mat')) {
    var btnTxt = $('#AddToCartText-product').text();
    if(btnTxt.includes('Sold out')) {
      setTimeout(function() {
        $('#AddToCart-product').addClass('soldOutPicnic');
      }, 1000);
    }
  }
});

/*--Update stock in Berry Bowls Workshops--*/
$(document).ready(function() {
  var stock = $('#berry-bowls-workshop #ProductSelect-product').find(':selected').attr('var_qty');
  $('#berry-bowls-workshop .variant-inventory').text(stock + ' LEFT IN STOCK');
  $('#berry-bowls-workshop #ProductSelect-product').click(function() {
    stock = $(this).find(':selected').attr('var_qty');
    $('.variant-inventory').text(stock + ' LEFT IN STOCK');
  })
});

/*--Remove CFAs fields from grasscloth products--*/
$(document).ready(function() {
  var productTitle;
  let grasscloth = false;
  let otherProduct = false;
  $('.cart__row').each(function() {
    productTitle = $(this).find('.cart__item__title .h4--body').text();
    if(productTitle.includes('Grasscloth')) {
      grasscloth = true;
    } else if(!productTitle.includes('Dropship') && productTitle !== '' && productTitle !== null) {
      otherProduct = true;
    }
  });
  if(grasscloth && !otherProduct) {
    $('.cfa-request').css('display','none');
  }
});  

/*--------Fix Sold Out text button when variant is available-------*/
$(document).ready(function() {
  var stock = $(' #ProductSelect-product').find(':selected').attr('var_qty');
  if(stock > 0) {
    $('#berry-bowls-workshop #AddToCartText-product').text('ADD TO CART');
    if(!$('.variant-inventory').text().includes('stock')) {
      //<p class="variant-inventory text-center uppercase" style="margin-top:1em">1 left in stock</p>
      $('#productInfo-product .h2').after('<p class="variant-inventory text-center uppercase" style="margin-top:1em"> left in stock</p>');
      $('#berry-bowls-workshop .variant-inventory').text(stock + ' LEFT IN STOCK');
    }
  }
});

/*--------------Change error text for in-stock-product-------------*/
/*$(document).ready(function() {
    $('.js-qty__adjust').click(function(){
      setTimeout(function(){
        //if(errorMessage.indexOf("In stock are in your cart") != -1) {
          $('.errors')[0].innerHTML  = 'Product is Made to Order';
        //}
      }, 1000);
    });
});*/

/*-------Change Add To Cart button on Sold-Out variant------------*/
$(document).ready(function() {
  $('.add-to-cart__wrapper').append('<button class="soldOutBtn">Sold Out</button>');
  $('.soldOutBtn').css('display','none');
  let defaultVariant = $('.single-option-selector').find(":selected").text();
  $('.single-option-selector').change(function () {
    var variantSelected = $(this).find("option:selected");
    if(variantSelected.text().includes('Sold Out')) {
          $('.add-to-cart__wrapper #AddToCart-product-alternate').css('display', 'none');
          $('.soldOutBtn').css('display','block');
          // @lifeblue v1.1.3 - ensuring sold out button is always disabled
          $('.soldOutBtn').prop('disabled', true);
    } else {
      $('.soldOutBtn').css('display','none');
      $('.add-to-cart__wrapper #AddToCart-product-alternate').css('display', 'block');
    }
  });
});


[
  {
    "id":47546187645178,
    "title":"Lake",
    "option1":"Lake",
    "option2":null,
    "option3":null,
    "sku":"1500-01-S",
    "requires_shipping":true,
    "taxable":true,
    "featured_image":{"id":43985784439034,"product_id":8868753637626,"position":1,"created_at":"2025-05-15T13:34:40-05:00","updated_at":"2025-07-16T17:29:42-05:00","alt":null,"width":1620,"height":1458,"src":"\/\/erikampowell.myshopify.com\/cdn\/shop\/files\/Off_the_Hook_Website_Thumbnail_Template_Brown_1afd6822-1460-46b3-aff3-d6025a0beaeb.jpg?v=1752704982","variant_ids":[47546187645178]},
    "available":true,
    "name":"OFF THE HOOK SWATCHES - Lake",
    "public_title":"Lake",
    "options":["Lake"],
    "price":400,
    "weight":0,
    "compare_at_price":null,
    "inventory_quantity":30,
    "inventory_management":"shopify",
    "inventory_policy":"deny",
    "barcode":"",
    "featured_media":{"alt":null,"id":36039556792570,"position":1,"preview_image":{"aspect_ratio":1.111,"height":1458,"width":1620,"src":"\/\/erikampowell.myshopify.com\/cdn\/shop\/files\/Off_the_Hook_Website_Thumbnail_Template_Brown_1afd6822-1460-46b3-aff3-d6025a0beaeb.jpg?v=1752704982"}},
    "requires_selling_plan":false,
    "selling_plan_allocations":[]},
  {"id":47546187710714,"title":"Sea","option1":"Sea","option2":null,"option3":null,"sku":"1500-02-S","requires_shipping":true,"taxable":true,"featured_image":{"id":43985784471802,"product_id":8868753637626,"position":2,"created_at":"2025-05-15T13:34:40-05:00","updated_at":"2025-07-16T17:29:42-05:00","alt":null,"width":1620,"height":1458,"src":"\/\/erikampowell.myshopify.com\/cdn\/shop\/files\/Off_the_Hook_Website_Thumbnail_Template_Blue_989b9ff7-dbe9-49ef-ae04-d948a33ef19e.jpg?v=1752704982","variant_ids":[47546187710714]},"available":true,"name":"OFF THE HOOK SWATCHES - Sea","public_title":"Sea","options":["Sea"],"price":400,"weight":0,"compare_at_price":null,"inventory_quantity":30,"inventory_management":"shopify","inventory_policy":"deny","barcode":"","featured_media":{"alt":null,"id":36039556759802,"position":2,"preview_image":{"aspect_ratio":1.111,"height":1458,"width":1620,"src":"\/\/erikampowell.myshopify.com\/cdn\/shop\/files\/Off_the_Hook_Website_Thumbnail_Template_Blue_989b9ff7-dbe9-49ef-ae04-d948a33ef19e.jpg?v=1752704982"}},"requires_selling_plan":false,"selling_plan_allocations":[]},{"id":47546187776250,"title":"Bay","option1":"Bay","option2":null,"option3":null,"sku":"1500-03-S","requires_shipping":true,"taxable":true,"featured_image":{"id":43985784537338,"product_id":8868753637626,"position":3,"created_at":"2025-05-15T13:34:40-05:00","updated_at":"2025-07-16T17:29:42-05:00","alt":null,"width":1620,"height":1458,"src":"\/\/erikampowell.myshopify.com\/cdn\/shop\/files\/Off_the_Hook_Website_Thumbnail_Template_Green_f6569ba8-fbae-496e-be34-b5b070f054c2.jpg?v=1752704982","variant_ids":[47546187776250]},"available":true,"name":"OFF THE HOOK SWATCHES - Bay","public_title":"Bay","options":["Bay"],"price":400,"weight":0,"compare_at_price":null,"inventory_quantity":30,"inventory_management":"shopify","inventory_policy":"deny","barcode":"","featured_media":{"alt":null,"id":36039556825338,"position":3,"preview_image":{"aspect_ratio":1.111,"height":1458,"width":1620,"src":"\/\/erikampowell.myshopify.com\/cdn\/shop\/files\/Off_the_Hook_Website_Thumbnail_Template_Green_f6569ba8-fbae-496e-be34-b5b070f054c2.jpg?v=1752704982"}},"requires_selling_plan":false,"selling_plan_allocations":[]}]

/*------------Add info text about how to increase/decrease quantity of grasscloth product quickly-------------------------------*/
$(document).ready(function() {
  var path = window.location.href;
  if(path.toString().includes('grasscloth')) {
    console.log('lets increase those grassclothes');
    $('#Quantity-product').after('<p class="infoQuantity"><i>To increase quantity either press the plus button or click on the number and use the up arrow key.</i></p>');
  }
});

/*-----------------------------------------disable out of stock button----------------------------------------------------------*/
$(document).ready(function() {
      let buttonVal = $('.product-section .add-to-cart__wrapper button').text();
    
  //Product alternate
      if(buttonVal === 'Out of stock') {
        $('.product-section .add-to-cart__wrapper button').prop('disabled', true);
        $('.gw-button-widget').prop('disabled', false);
        $('.product-section .add-to-cart__wrapper button').addClass('noBorder');
        $('.gw-button-widget').removeClass('noBorder');
      } else {
        $('.product-section .add-to-cart__wrapper button').prop('disabled', false);
        $('.gw-button-widget').prop('disabled', false);
        $('.product-section .add-to-cart__wrapper button').removeClass('noBorder');
      }
      
      //@lifeblue v1.1.13 | Ajusted this so it loops through all buttons since we now also have the buy a swatch button, which we don't want to disable
      $('.product-section .quantity-selector').click(function() {
        $('.product-section .add-to-cart__wrapper button').each(function() {
            let $currentButton = $(this);
            let buttonVal = $currentButton.text();
            
            if (buttonVal === 'Out of stock') {
                $currentButton.prop('disabled', true);
                $currentButton.addClass('noBorder');
                $('.gw-button-widget').prop('disabled', false);
                $('.gw-button-widget').removeClass('noBorder');
            } else {
                $currentButton.prop('disabled', false);
                $currentButton.removeClass('noBorder');
                $('.gw-button-widget').prop('disabled', false);
            }
        });
    });
  
});

/*-----------------------------------------disable sold out button----------------------------------------------------------*/
$(document).ready(function() {
      let soldOutBtnVal = $('#AddToCart-product span').text();
      if(soldOutBtnVal === 'Sold out') {
        $('#AddToCart-product').prop('disabled', true);
        $('#AddToCart-product').addClass('noBorder');
      } else {
        $('#AddToCart-product').prop('disabled', false);
        $('#AddToCart-product').removeClass('noBorder');
      }
});



/*-------------------------------------show notify me button for Porch Perfect Pillows-----------------------------------------*/
// $(document).ready(function() {
//   setTimeout(function() {
//     if($('#ProductSection-porch-perfect-pillow')) {
//       $('.gw-button-widget').addClass('showMe');
//       //$('.add-to-cart__wrapper a').css('display', 'none');
//     }
//   },1000);

// });




/*-------------------------------------0E1-T484 - Make all Porch Perfect Pillow Code live - 8/18/24 - Andrew-----------------------------------------*/
// Wait for the whole document to load (the whole page)
//$(document).ready(function() {
  //Get current url of the page
  //let path = window.location.href;
  //Check if that product includes the porch perfect pillow / for each porch perfect product you will need to add its url
  // Instead updated this to include all Porch Perfect Pillows at once. 
  //if(path.includes('porch-perfect-pillow')) {
      
  // This is backup code below. I'm not sure what it's all for - 8/18/24 - Andrew
      //$('#ProductSection-porch-perfect-pillow').css('display','none');
      //$('#Quantity-pillow-products input').css('display', 'none');
      //$('#Quantity-pillow-products .quantity__minus').after('<input id="evenInput" type="number" class="" name="quantity" value="2" min="2" aria-label="quantity" pattern="[0-9]*" mm-min="2" mm-stock-max="NaN" step="2" mm-step="2">');

 // }
//});



/* 0E1-T502: Launching Porch Perfect Pillows (New Plan - Simplified Development) - 08/31/24 Harwinder  */

// Doc ready statement to make sure it loads after the document is loaded.
$(document).ready(function() {
  //Get current url of the page
  let path = window.location.href;
  //Check if that product includes the porch perfect pillow / for each porch perfect product you will need to add its url
  // Instead updated this to include all Porch Perfect Pillows at once. 
  if(path.includes('porch-perfect-pillow')) {


/*---------------[0E1-T510: Porch Perfect Pillows - Remove the Buy a Swatch button - 10.Sept.2024 - Harwinder] ------------------*/

    // selecting all button elements
    let swatchButtonPorchPerfectPillow = document.querySelectorAll("div.add-to-cart__wrapper > a");
    // looping through all the button elemnts
    swatchButtonPorchPerfectPillow.forEach((b, i) => {
      // checking if the href includes "swatch" keyword
      if(b?.getAttribute('href').includes("swatch")) {
        // hiding if the url includes swatch
        b.style.display = 'none';
      } // end if
    }) // end foreach loop

 /*---------------------- COPIED FROM LINE 1522 to 1588:: Make quantity select into even numbers only ------------------*/
    
  //Initialize variables  
  let sum = 2;   
  let rest = 0;    
  let currVal = 2;     
  let selectorValue;   
  let fullSelectorValue;    
  let hiddenSelectorVariant;      
  let hiddenSelectorVariantQty;   
  let selectedIndex    
  let selectedQty = $('#Quantity-pillow-products input').val();  

  //Get stock for the product
  let stock = $('#ProductSelect-pillow-products').find(':selected').attr('var_qty');

  // set quantity min to 1
    $('#Quantity-pillow-products input').attr("min", "1");


  /*----------------------Rewrite variant names------------------*/
  //Initialize variables  

  // Purpose of this variable:   
  let valueToRewrite;
  // Purpose of this variable:       
  let noQuoteValue;
  // Purpose of this variable:       
  let valueToRewriteNoSpace;   

  //Go through each option of the visible selector of the product page  
  $('.single-option-selector option').each(function() {
    //Get the value of the current variant
    valueToRewrite = $(this).attr('value');
    //Remove spaces from the variable
    valueToRewriteNoSpace = valueToRewrite.replace(/\s/g, '')
    //Check if the variable contains " (for inches)
    if(valueToRewriteNoSpace.indexOf('"') >= 0) {
      //Remove the "(inches) from the value, so the code can work as it can not select correctly for example when the value already have quotes, for example value="value With inches" "
      noQuoteValue = valueToRewriteNoSpace.replace(/\"/g, "");
      //Now we add the correct value, for example value="value with no inches" to the visible selector of the product page 
      $(this).attr('value',noQuoteValue);
    }
  });

  //Go through each option of the hidden selector of the product page 
  $('#ProductSelect-pillow-products option').each(function() {
    //Get the current value
    valueToRewrite = $(this).text();
    //Remove spaces from the variable
    valueToRewriteNoSpace = valueToRewrite.replace(/\s/g, '');
    //Check if the variable contains " (for inches)
    if(valueToRewriteNoSpace.indexOf('"') >= 0) {
      //Remove the "(inches) from the value, so the code can work as it can not select correctly for example when the value already have quotes, for example value="value With inches" "
      noQuoteValue = valueToRewriteNoSpace.replace(/\"/g, "");
      //Now we add the correct value, for example value="value with no inches" to the hidden selector of the product page 
      $(this).attr('data-name',noQuoteValue);
    }
  });


    /*-------------------------------------Change font-size of Porch-perfect-pillows-----------------------------------------*/
    // selecting the small poduct title
    let smallTitle = $('#productInfo-pillow-products .h2').text();
      // replacing the text within smallTitle tag with Porch Perfect Pillow
    let newSmallTitle = smallTitle.replace('Porch Perfect Pillow','');
      // Adding a new element below the smallTitle 
    $('#productInfo-pillow-products .h2').after('<div class="porch-title-container"><span class="porch-big-title">PORCH PERFECT PILLOW</span><span class="porch-small-title">' + newSmallTitle + '</span></div>')
      // hiding smalTitle 
    $('#productInfo-pillow-products .h2').css('display', 'none');

    /*----------------------When visual variant selector is clicked change in-stock/made-to-order state and button------------------*/  
  //When the visual variant selector is clicked change the text for the corresponding button either in stock - Add to cart button OR made-to-order Pre-order with a 10 week lead time   
  $('.single-option-selector').click(function(){
     //Get the current quantity in the quantity input
     currVal = $('#Quantity-pillow-products input').val();
     //Get the selected variant value from the visible selector 
     selectorValue = $(this).find("option:selected").attr('value');
     //Add InStock to the end of the selected variant from the visible selector that we will use to check with the variant of the hidden selector which appears like variantInStock or variantMadetoorder
     fullSelectorValue = selectorValue + '/InStock';
     //Add Madetoorder to the end of the selected variant from the visible selector that we will use to check with the variant of the hidden selector which appears like variantInStock or variantMadetoorder
     fullSelectorValueMadeToOrder = selectorValue + '/MadeToOrder'; // changed madetoorder to MadeToOrder to fix 0E1-T497
     //Get the hidden selector variant by its value
     hiddenSelectorVariant = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']");
     //Get the quantity of the hidden selector variant
     hiddenSelectorVariantQty = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']").attr('data-qty');
    //Check if the the selected variant quantity of the hidden selector is undefined or less than the current quantity in the quantity input box
    if(hiddenSelectorVariantQty === undefined || hiddenSelectorVariantQty === null || hiddenSelectorVariantQty < parseInt(currVal)) {
      //Show the add to cart butto
      $('#AddToCart-porch-perfect-pillow').prop('disabled', false);
     //Change the text of the button
      // $('#AddToCart-porch-perfect-pillow').text('Pre-order with a 10 week lead time');
      //Get the current index of the size visual selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
     //select the 'made to order' option in the hidden selector by the value
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValueMadeToOrder + '"]').prop('selected', true);
      //.prop('selected', true);
    } else {
      //Change the text back to add to cart
      $('#AddToCart-porch-perfect-pillow').text('Add to Cart');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //select the 'in-stock' option in the hidden selector by the value
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValue + '"]').prop('selected', true);
    }   
  });

  /*----------------------Inititate in-stock/made-to-order state and button------------------*/  
  //Initiate quantity selector to 2
  $('#Quantity-pillow-products input').val(sum);
      //Select the correct product and change the text for the corresponding button either in stock - Add to cart button OR made-to-order Pre-order with a 10 week lead time       
      setTimeout(function() {
               //Correct selector on page load
               //Get the current quantity in the quantity input
               currVal = $('#Quantity-pillow-products input').val();
               //Get the selected variant value from the visible selector 
               selectorValue = $('.single-option-selector').find(":selected").attr('value');
               //Add InStock to the end of the selected variant from the visible selector that we will use to check with the variant of the hidden selector which appears like variantInStock or variantMadetoorder 
               fullSelectorValue = selectorValue + '/InStock';
               //Add Madetoorder to the end of the selected variant from the visible selector that we will use to check with the variant of the hidden selector which appears like variantInStock or variantMadetoorder
               fullSelectorValueMadeToOrder = selectorValue + '/MadeToOrder'; // changed madetoorder to MadeToOrder to fix 0E1-T497
               //Get the hidden selector variant by its value
               hiddenSelectorVariant = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']");
               //Get the quantity of the hidden selector variant
               hiddenSelectorVariantQty = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']").attr('data-qty');
              //Check if the selected variant quantity of the hidden selector is undefined or less than the current quantity in the quantity input box
              if(hiddenSelectorVariantQty === undefined || hiddenSelectorVariantQty === null || hiddenSelectorVariantQty < parseInt(currVal)) {
                //If it is display the 
                //Make the button enabled
      
                $('#AddToCart-pillow-products').prop('disabled', false);
                //Change the text of the button
                //@lindsay this is on init 
                // $('#AddToCart-pillow-products').text('Pre-order with a 10 week lead time');
                //Get the current index of the size visual selector
                selectedIndex = $('.single-option-selector').prop('selectedIndex');
                //select the 'made to order' option in the hidden selector by the value
                    //$('#ProductSelect-pillow-products option:eq(' + selectedIndex + 1 + ')').prop('selected', true);
              
              
              // Using the custom escape function
              var escapedValue = escapeSelector(fullSelectorValueMadeToOrder);
              $('#ProductSelect-pillow-products option[data-name="' + escapedValue + '"]').prop('selected', true);

              //.prop('selected', true);
              } else {
                //Change the text back to add to cart
                $('#AddToCart-pillow-products').text('Add to Cart');
                //Get the current index of the size selector
                selectedIndex = $('.single-option-selector').prop('selectedIndex');
                //select the 'in-stock' option in the hidden selector by the value
                $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValue + '"]').prop('selected', true);
                  // closing else
              }
         // end setTimeout with half a second of time
      }, 500);


    // Checking if stock is greater than 1
    if(stock > 1) {
        //setting the default quantity to 2
      $('#Quantity-pillow-products input').val(sum);
        // end if
    }


    /*----------------------COPIED FROM 1654-1686:: When plus selector is clicked change in-stock/made-to-order state, button and add 2------------------*/    
  //Sum in even intervals
    //Click function when the plus icon of the quantity selector is clicked (changed jquery event listener to vanilla js event listener to avoid conflicts with document.ready)
  document.querySelector('#Quantity-pillow-products .quantity__plus').addEventListener('click', function() { 
    // if value is not 1 then add 2 else add 1 in the quantity (value will not go below 2 but handling 1 is a safecase. if by any change minus functionality brakes )
    sum = parseInt($('#Quantity-pillow-products input').val(), 10) !== 1 ? (parseInt($('#Quantity-pillow-products input').val(), 10) + 1) : parseInt($('#Quantity-pillow-products input').val(), 10);
    //Set the value
    $('#Quantity-pillow-products input').val(sum);
    //FROM HERE UNTIL THE END IS THE SAME AS THE SELECTOR CLICK FUNCTION
     selectorValue = $('.single-option-selector').find(":selected").attr('value');
      // setting a variable with variant value and Instock
     fullSelectorValue = selectorValue + '/InStock';
      // setting a variable with variant value and madetoorder
     fullSelectorValueMadeToOrder = selectorValue + '/MadeToOrder'; // changed madetoorder to MadeToOrder to fix 0E1-T497
      // selecting the hidding variant id seletor with instock variable
     hiddenSelectorVariant = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']");
      // setting the hidden selector instock quantity into data-qty attribute
     hiddenSelectorVariantQty = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']").attr('data-qty');
    //Check if the button is out-of-stock so we need to change it to made to order
    if(hiddenSelectorVariantQty === undefined || hiddenSelectorVariantQty === null || hiddenSelectorVariantQty < parseInt(sum)) {
      //Make it enable
      $('#AddToCart-pillow-products').prop('disabled', false);
      //Change the text
      //@lindsay this is the text that changes when you increase inventory
      // $('#AddToCart-pillow-products').text('Pre-order with a 10 week lead time');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //Add one to that index to select the 'made to order' option in the hidden selector
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValueMadeToOrder + '"]').prop('selected', true);
      //.prop('selected', true);
    } else {
      //Change the text back to add to cart
      $('#AddToCart-pillow-products').text('Add to Cart');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //Add one to that index to select the 'made to order' option in the hidden selector
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValue + '"]').prop('selected', true);
        // end else
    }
      // end event listener
  });

    /*----------------------COPIED FROM 1699-1740:: When minus selector is clicked change in-stock/made-to-order state, button and rest 2------------------*/   
  // changed jquery event listener to vanilla js event listener to avoid conflicts with document.ready
   document.querySelector('#Quantity-pillow-products .quantity__minus').addEventListener('click',function() {
    // Dont let it go below 2 (Using a ternary operator to determine the next value based on the current value)
    rest = parseInt($('#Quantity-pillow-products input').val(), 10) !== 1 ? (parseInt($('#Quantity-pillow-products input').val(), 10) !== 2 ? (parseInt($('#Quantity-pillow-products input').val(), 10) -1) : parseInt($('#Quantity-pillow-products input').val(), 10))  : parseInt($('#Quantity-pillow-products input').val(), 10) + 1;
     //rest = (parseInt($('#Quantity-pillow-products input').val())) - 1; // subtracting 1 as 1 is subtracted by default making the subtracted number 2
    $('#Quantity-pillow-products input').val(rest);
     //FROM HERE UNTIL THE END IS THE SAME AS THE SELECTOR CLICK FUNCTION
    //Get the selected option value
     selectorValue = $('.single-option-selector').find(":selected").attr('value');
      // setting a variable with variant value and Instock
     fullSelectorValue = selectorValue + '/InStock';
     // setting a variable with variant value and madetoorder
     fullSelectorValueMadeToOrder = selectorValue + '/MadeToOrder';  // changed madetoorder to MadeToOrder to fix 0E1-T497
     // selecting the hidding variant id seletor with instock variable
     hiddenSelectorVariant = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']");
     // setting the hidden selector instock quantity into data-qty attribute
     hiddenSelectorVariantQty = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']").attr('data-qty');
    //Check if the button is out-of-stock so we need to change it to made to order
    if(hiddenSelectorVariantQty === undefined || hiddenSelectorVariantQty === null || hiddenSelectorVariantQty < parseInt(rest)) {
      //Make it enable
      $('#AddToCart-pillow-products').prop('disabled', false);
      //Change the text
      //@lindsay this is the text that happens when you decrease inventory
      // $('#AddToCart-pillow-products').text('Pre-order with a 10 week lead time');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //Add one to that index to select the 'made to order' option in the hidden selector
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValueMadeToOrder + '"]').prop('selected', true);
    } else {
      //Change the text back to add to cart
      $('#AddToCart-pillow-products').text('Add to Cart');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //Add one to that index to select the 'made to order' option in the hidden selector
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValue + '"]').prop('selected', true);
    }
  // end event listener
  });

    //Disable input to avoid increasing through keyup event
    $('#Quantity-pillow-products input').css('pointer-events', 'none');


    /*------------------------ 0E1-T496: Make porch perfect pillow - size select, quantity select, and button work together seamlessly - Harwinder ------------------------*/

    //function to reset qauntity back to 2 and handle Add to cart button in-stock made-to-order state whenever the variant is changed
    const resetQuantityAndHandleCartButton = () => {
      // resetting quantity to 2
      $('#Quantity-pillow-products input').val(2);

      // change in-stock made-to-order state (using the same old code)
      selectorValue = $('.single-option-selector').find(":selected").attr('value');
       // setting a variable with variant value and Instock
     fullSelectorValue = selectorValue + '/InStock';
      // setting a variable with variant value and madetoorder
     fullSelectorValueMadeToOrder = selectorValue + '/MadeToOrder'; // // changed madetoorder to MadeToOrder to fix 0E1-T497
      // selecting the hidding variant id seletor with instock variable
     hiddenSelectorVariant = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']");
      // setting the hidden selector instock quantity into data-qty attribute
     hiddenSelectorVariantQty = $("#ProductSelect-pillow-products option[data-name='" + fullSelectorValue + "']").attr('data-qty');
    if(hiddenSelectorVariantQty === undefined || hiddenSelectorVariantQty === null || hiddenSelectorVariantQty < parseInt(rest)) {
      //Make it enable
      $('#AddToCart-pillow-products').prop('disabled', false);
      //Change the text
      //@lindsay - this is the text when it changes variants
      // $('#AddToCart-pillow-products').text('Pre-order with a 10 week lead time');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //Add one to that index to select the 'made to order' option in the hidden selector
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValueMadeToOrder + '"]').prop('selected', true);
    } else {
      //Change the text back to add to cart
      //@lindsay this is the one 
      // $('#AddToCart-pillow-products').text('Add to Cart');
      //Get the current index of the size selector
      selectedIndex = $('.single-option-selector').prop('selectedIndex');
      //Add one to that index to select the 'made to order' option in the hidden selector
      $('#ProductSelect-pillow-products option[data-name="' + fullSelectorValue + '"]').prop('selected', true);
    }
      //----- end of "change in-stock made-to-order state"
    }

    // event listener for whenever the varient is changed
    document.querySelector("#SingleOptionSelector-pillow-products-0").addEventListener("change", (e) => {
      // resetting quantity to 2
      resetQuantityAndHandleCartButton();
      // end event listener
    });


/*------------------- [0E1-T504: Porch Perfect Pillow - when clicking thumbnail the Add to Cart button does not change - Harwinder] ---------------*/
    // Looping through all the avaible product options and adding eventlistener to each option (means whenever any option is changed through image thumbnail or otherwise it will reset the value to 2 and change the add to cart button text accordingly)
    
    // looping through the product options
    productOptions.forEach((p, i) => { //loop start
       // event listener for whenever the varient is changed via image thumbnail or otherwise
       $('.single-option-selector:eq('+i+')').on("change", function() {
        // resetting quantity to 2
        resetQuantityAndHandleCartButton();
        // end event listener
      });
      // end loop
    })

// ----------------------- [END of 0E1-T504]----------------------------------------------------
    
    
    // // FIX: There are two "Buy a Swatch" buttons in PORCH PERFECT PILLOW in Petite Cross + Dot Grove
    // if(path.includes("porch-perfect-pillow-in-petite-cross-dot-grove")) { // check if the product is PORCH PERFECT PILLOW in Petite Cross + Dot Grove
    //   // select all the buy swatch buttons from the DOM.
    //   const swatchButtons = document.querySelectorAll("#product_form_8587523162362 > div.add-to-cart__wrapper > a[href='/collections/swatches/products/copy-of-petite-cross-dot']");
    //   if(swatchButtons.length > 1) { // check if the buttons are more than 1
    //     swatchButtons.forEach((b, i) => (b.style.display = i === 0 ? "block" : "none"));// if there are more than 1 buttons hide all except the first one
    //   } // end if
    // } // end if
    
  } // end of porch-perfect-pillow main if statement

  /*-------------------------------------0E1-T482 - Make Porch Perfect Quantity not change on Cart page - made live 8/18/24 - Andrew -----------------------------------------*/
      //Check if that product includes the porch perfect pillow / for each porch perfect product you will need to add its url
    if(path.includes('/cart')) {
      //Make qty input unclickable on the cart page (AS WELL IN THEME.JS FILE TOP UPDATE WHEN QTY CHANGES)
      //Iterare over each product row  
      $('.tpo_item-product').each(function() {
        //Get the product title
        let productTitle = $(this).find('.cart__item__title a').text();
        //Check if the product title contains porch perfect pillow
        if(productTitle.includes('Porch Perfect Pillow')) {
          //Make the quantity selector unclikable and the quantity select options hidden
          $(this).find('.quantity-selector').css('pointer-events', 'none');
          
        // end if statement
        } 
      // end each function 
      }); 
      // end path selection
    } 
  
  
}); // end of document ready







